import {
    useCallback,
} from 'react'

import {
    useMutation,
} from '@tanstack/react-query'

import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import locationRequests from 'app/requests/Location.requests'
import {
    Location,
} from '../Locations.types'

const useUpdateLocation = ({
    onSuccess,
}:{onSuccess: () => void}) => {
    const token = useJWTToken()

    const {
        onSuccess: onSuccessUpdateLocation,
        onError,
    } = useHandleStatusRequest({
        title: 'Location was updated',
        id: 'LocationCreated',
        onSuccess,
    })

    const {
        mutate: updateLocation,
    } = useMutation({
        mutationFn: (location: Location) => {
            return simpleApi({
                ...locationRequests.update({
                    data: location,
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessUpdateLocation,
    })

    return useCallback((location: Location) => {
        updateLocation(location)
    }, [updateLocation])
}

export default useUpdateLocation
